/** Search for the admin pages: the same word matching as
 *  the station search (lib/stationSearch), applied to the lists that grow —
 *  users, parameters (thousands once every gateway column has one), the
 *  audit log. */
import type { AdminParameter, AppUser, AuditEntry } from '../api/types'
import { searchTerms } from './stationSearch'

/** Every word of the query appears in one of the fields, in any order. */
export function matchesQuery(fields: (string | null | undefined)[], query: string): boolean {
  const terms = searchTerms(query)
  if (!terms.length) return true
  const text = searchTerms(fields.filter(Boolean).join(' ')).join(' ')
  return terms.every((term) => text.includes(term))
}

export function filterParameters<T extends Pick<AdminParameter,
  'code' | 'display_name' | 'unit' | 'axis_group' | 'kind'>>(params: T[], query: string): T[] {
  return params.filter((p) =>
    matchesQuery([p.code, p.display_name, p.unit, p.axis_group, p.kind], query))
}

export function filterUsers(users: AppUser[], query: string): AppUser[] {
  return users.filter((u) => matchesQuery([u.display_name, u.email, u.role], query))
}

/** An audit entry's detail as the table writes it: key=value, nulls left
 *  out, two spaces between. */
export function auditText(detail: Record<string, unknown> | null): string {
  if (!detail) return ''
  return Object.entries(detail)
    .filter(([, value]) => value !== null)
    .map(([key, value]) => `${key}=${JSON.stringify(value)}`)
    .join('  ')
}

export function filterAudit(entries: AuditEntry[], query: string): AuditEntry[] {
  return entries.filter((e) => matchesQuery(
    [e.actor, e.action, e.entity, e.entity_id, auditText(e.detail)], query))
}
